"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsIssueValueEmpty = exports.getDefaultIssueStatus = exports.getAreAllRequiredFieldsFilled = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _sdk = require("../../../sdk");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _issueStandardFields = require("./issueStandardFields");
const getIsIssueValueEmpty = value => {
  return value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0;
};
exports.getIsIssueValueEmpty = getIsIssueValueEmpty;
const getAreAllRequiredFieldsFilled = _ref => {
  let {
    fieldsMetadata,
    issue
  } = _ref;
  const requiredFields = fieldsMetadata.filter(_ref2 => {
    let {
      required
    } = _ref2;
    return !!required;
  });
  return requiredFields.every(field => {
    const value = (0, _issueStandardFields.getIssueValueFromFieldMetadata)({
      field,
      issue
    });
    return !getIsIssueValueEmpty(value);
  });
};

/**
 * Returns the default issue status for a given issue based on required fields
 */
exports.getAreAllRequiredFieldsFilled = getAreAllRequiredFieldsFilled;
const getDefaultIssueStatus = exports.getDefaultIssueStatus = (0, _toolkit.createSelector)(_issueTypes.getIssueTypeEntitiesMap, issueTypeEntitiesMap => issueData => {
  const typeId = issueData === null || issueData === void 0 ? void 0 : issueData.issueTypeId;
  if (issueData.status !== _sdk.IssueStatus.Draft && typeId) {
    var _issueType$fieldsMeta;
    const issueType = issueTypeEntitiesMap[typeId];
    const areAllRequiredFieldsFilled = getAreAllRequiredFieldsFilled({
      fieldsMetadata: (_issueType$fieldsMeta = issueType === null || issueType === void 0 ? void 0 : issueType.fieldsMetadata) !== null && _issueType$fieldsMeta !== void 0 ? _issueType$fieldsMeta : [],
      issue: issueData
    });
    if (!areAllRequiredFieldsFilled) {
      return _sdk.IssueStatus.Draft;
    }
  }
  return issueData.status || _sdk.IssueStatus.Open;
});
//# sourceMappingURL=issueRequiredFields.js.map